/*
 |--------------------------------------------------------------------------
 | UI / mutations.js
 |--------------------------------------------------------------------------
 */

import * as mutation from './mutation_types'

export default {
    [mutation.SET_IS_MOBILE](state, flag) {
        state.global.isMobile = flag
    },
    [mutation.SET_VIEWPORT_HEIGHT](state, height) {
        state.viewport.height = height
    },
    [mutation.SET_RECOMMENDATION](state, recommendation) {
        state.overlay.recommendation = recommendation
    },
    [mutation.SET_FEEDBACK](state, feedback) {
        state.overlay.feedback = feedback
    },
    [mutation.SET_MAP](state, map) {
        state.overlay.map = map
    },
    [mutation.SET_TRANSLATION](state, translation) {
        state.global.translation = translation
    },
    [mutation.SET_CURRENT_LANGUAGE](state, language) {
        state.global.detectedLanguage = language
    },
    [mutation.SET_CURRENT_COORDINATES](state, coordinates) {
        state.global.currentCoordinates = coordinates
    }
}
